import { useAuth } from "@/context/AuthContext";
import { endPreviewSession } from "@/lib/api";
import { Eye, X } from "lucide-react";

export default function ViewAsBanner() {
  const { user } = useAuth();
  if (!user?.readonly) return null;
  const exit = () => { endPreviewSession(); window.close(); setTimeout(() => window.location.assign("/admin"), 150); };
  return (
    <div data-testid="view-as-banner" className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-400 px-4 py-2 text-center text-xs font-bold text-amber-950 shadow-md sm:text-sm">
      <Eye className="h-4 w-4" />
      <span>Viewing as <span data-testid="view-as-name">{user.winner_name || user.email}</span> ({user.email}) — read-only preview, changes are disabled.</span>
      <button data-testid="view-as-exit-btn" onClick={exit} className="inline-flex items-center gap-1 rounded-full bg-amber-950 px-3 py-1 text-xs font-bold text-amber-100 hover:bg-amber-900">
        <X className="h-3 w-3" /> Exit preview
      </button>
    </div>
  );
}
